<nav class="flex items-center w-full shadow-sm flex-shrink-0 px-[24px] py-[14px]">
  <div class="flex items-center w-full">
    <div>
      <h1 class="heading-24 font-semibold leading-[26px]">MPM DIVE</h1>
      <p class="text-[12px] leading-[20px] font-normal">DIGITAL REVIEW & INTEGRATED VIRTUAL SUITES</p>
    </div>

    <div class="ml-auto flex items-center gap-x-[16px]">
      <button
              type="button h-[32px] w-[32px] p-[4px] flex items-center justify-center">
        <lib-help-icon />
      </button>

      <lib-notification-button />

      <lib-profile [profile]="profile" />
    </div>
  </div>
</nav>
